import { isValid, parseISO } from 'date-fns';

const localDateTimeInputToUtc = (value?: string | Date | null): string | null => {
  if (!value) return null;

  const date = typeof value === 'string' ? parseISO(value) : value;

  return isValid(date) ? date.toISOString() : null;
};

export default localDateTimeInputToUtc;
